<template>
    <div id="applied">
        <navbar clickable="true"></navbar>
        <div id="sections-area">
          <section id="hero-section">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;;display:block;z-index:-1;position:absolute" width="100%" height="100%" preserveAspectRatio="xMidYMid" viewBox="0 0 1920 969">
              <g transform="translate(960,484.5) scale(1,1) translate(-960,-484.5)">
                <g transform="translate(0 838.790940284774)"><g transform="translate(299.06824349805987 0)">
                  <g class="ld ld-fall" style="animation-delay:NaNs;animation-duration:4s">
                    <rect x="-5.4502072906537276" y="-3.2241526044151723" width="10.900414581307455" height="6.4483052088303445" style="transform:scale(1.8805918567902973)" fill="#532788"></rect>
                  </g></g><g transform="translate(718.1990114999495 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.677839993252265s;animation-duration:4s">
                    <rect x="-3.7211330195010732" y="-5.391514601646075" width="7.4422660390021464" height="10.78302920329215" style="transform:scale(2.6888714821198367)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(595.9398852852521 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.0591843330421922s;animation-duration:4s">
                    <rect x="-4.924878999749524" y="-5.37624453678729" width="9.849757999499047" height="10.75248907357458" style="transform:scale(1.5300086562751947)" fill="#30aeb3"></rect>
                  </g></g><g transform="translate(549.8978118517356 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.6733509291517423s;animation-duration:2s">
                    <rect x="-5.120062264281759" y="-4.559910912377425" width="10.240124528563518" height="9.11982182475485" style="transform:scale(3.1360704606610246)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(132.34777145804856 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.6032787949711231s;animation-duration:2s">
                    <rect x="-3.048700043294097" y="-5.724579973000816" width="6.097400086588194" height="11.449159946001632" style="transform:scale(2.6012583679366106)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(83.91574080128791 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.0210421824370806s;animation-duration:4s">
                    <rect x="-3.37110830236825" y="-4.595457859254078" width="6.7422166047365" height="9.190915718508156" style="transform:scale(2.9385526624301797)" fill="#14d1bd"></rect>
                  </g></g><g transform="translate(1764.7147635958934 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.157754217597798s;animation-duration:4s">
                    <rect x="-4.432924083581787" y="-4.625279284889955" width="8.865848167163573" height="9.25055856977991" style="transform:scale(3.1407511559743115)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(1910.2704826787935 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.290957480923753s;animation-duration:4s">
                    <rect x="-5.854869290987189" y="-3.6978921371945397" width="11.709738581974378" height="7.395784274389079" style="transform:scale(3.4468307952687653)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(1828.8730762135128 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.131982274736197s;animation-duration:2s">
                    <rect x="-5.034471541368394" y="-4.079974674018069" width="10.068943082736787" height="8.159949348036138" style="transform:scale(2.378372551746545)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(682.3642754013458 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.4565419833123796s;animation-duration:2s">
                    <rect x="-4.392877185135031" y="-4.77645355555183" width="8.785754370270062" height="9.55290711110366" style="transform:scale(3.375854985150244)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(1018.1159900005024 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.33674470699052206s;animation-duration:2s">
                    <rect x="-5.345231397356617" y="-3.672393309894562" width="10.690462794713234" height="7.344786619789124" style="transform:scale(2.9497855387819705)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(339.4364354818086 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.7415464507574536s;animation-duration:4s">
                    <rect x="-4.711706723621279" y="-5.860062091113398" width="9.423413447242558" height="11.720124182226796" style="transform:scale(2.6599190108527946)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(618.9583905309153 0)">
                  <g class="ld ld-fall" style="animation-delay:-2.1989349866092907s;animation-duration:4s">
                    <rect x="-3.746414852707554" y="-3.21876863909164" width="7.492829705415108" height="6.43753727818328" style="transform:scale(2.450224240057091)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(1782.9297463411203 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.3207226232822062s;animation-duration:4s">
                    <rect x="-4.601346584637512" y="-4.073538111374056" width="9.202693169275024" height="8.147076222748112" style="transform:scale(2.1403270985771865)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(383.1695592214287 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.9374452358128416s;animation-duration:4s">
                    <rect x="-3.916217684733142" y="-4.210113646033524" width="7.832435369466284" height="8.420227292067048" style="transform:scale(2.9535921992613954)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(1847.725070998445 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.3590319220526297s;animation-duration:2s">
                    <rect x="-3.977459267201921" y="-3.1235485507092466" width="7.954918534403842" height="6.247097101418493" style="transform:scale(2.2430813377704766)" fill="#14d1bd"></rect>
                  </g></g><g transform="translate(1717.5414124902895 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.8760297617069948s;animation-duration:2s">
                    <rect x="-4.755498020480631" y="-3.1631798184280324" width="9.510996040961261" height="6.326359636856065" style="transform:scale(2.2498640491176087)" fill="#532788"></rect>
                  </g></g><g transform="translate(1037.7011248682456 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.5773940374123856s;animation-duration:4s">
                    <rect x="-3.4465436850760267" y="-5.391612727414335" width="6.893087370152053" height="10.78322545482867" style="transform:scale(2.7116824249657636)" fill="#751da7"></rect>
                  </g></g><g transform="translate(474.3257856693144 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.3416058629384855s;animation-duration:2s">
                    <rect x="-4.100417576853397" y="-3.046403530329889" width="8.200835153706795" height="6.092807060659778" style="transform:scale(1.9767867057388697)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(484.77771529911206 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.8255453142379618s;animation-duration:4s">
                    <rect x="-3.744007503746709" y="-4.228125544918341" width="7.488015007493418" height="8.456251089836682" style="transform:scale(1.5226643880281645)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(602.2532804210856 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.331866850015472s;animation-duration:4s">
                    <rect x="-3.3580152237820715" y="-3.632689289055814" width="6.716030447564143" height="7.265378578111628" style="transform:scale(3.208446012693323)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(479.94201725590784 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.6819915207492251s;animation-duration:4s">
                    <rect x="-3.7502289982534567" y="-4.635770524727144" width="7.500457996506913" height="9.271541049454289" style="transform:scale(2.0507127176291475)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(358.3678429355483 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.0521038045671025s;animation-duration:4s">
                    <rect x="-3.076697144713918" y="-5.840158982850242" width="6.153394289427836" height="11.680317965700484" style="transform:scale(2.813297596574917)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(151.50499673536245 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.7350657345301244s;animation-duration:4s">
                    <rect x="-5.993483160798848" y="-5.561995388567664" width="11.986966321597697" height="11.123990777135328" style="transform:scale(2.803290489348631)" fill="#30aeb3"></rect>
                  </g></g><g transform="translate(1866.2436431744184 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.3054434278540157s;animation-duration:4s">
                    <rect x="-5.850897730384758" y="-5.489110700859982" width="11.701795460769516" height="10.978221401719964" style="transform:scale(2.595888774288065)" fill="#366fa9"></rect>
                  </g></g></g>
                <g transform="translate(0 -130.20905971522598)"><g transform="translate(299.06824349805987 0)">
                  <g class="ld ld-fall" style="animation-delay:NaNs;animation-duration:4s">
                    <rect x="-5.4502072906537276" y="-3.2241526044151723" width="10.900414581307455" height="6.4483052088303445" style="transform:scale(1.8805918567902973)" fill="#532788"></rect>
                  </g></g><g transform="translate(718.1990114999495 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.677839993252265s;animation-duration:4s">
                    <rect x="-3.7211330195010732" y="-5.391514601646075" width="7.4422660390021464" height="10.78302920329215" style="transform:scale(2.6888714821198367)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(595.9398852852521 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.0591843330421922s;animation-duration:4s">
                    <rect x="-4.924878999749524" y="-5.37624453678729" width="9.849757999499047" height="10.75248907357458" style="transform:scale(1.5300086562751947)" fill="#30aeb3"></rect>
                  </g></g><g transform="translate(549.8978118517356 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.6733509291517423s;animation-duration:2s">
                    <rect x="-5.120062264281759" y="-4.559910912377425" width="10.240124528563518" height="9.11982182475485" style="transform:scale(3.1360704606610246)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(132.34777145804856 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.6032787949711231s;animation-duration:2s">
                    <rect x="-3.048700043294097" y="-5.724579973000816" width="6.097400086588194" height="11.449159946001632" style="transform:scale(2.6012583679366106)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(83.91574080128791 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.0210421824370806s;animation-duration:4s">
                    <rect x="-3.37110830236825" y="-4.595457859254078" width="6.7422166047365" height="9.190915718508156" style="transform:scale(2.9385526624301797)" fill="#14d1bd"></rect>
                  </g></g><g transform="translate(1764.7147635958934 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.157754217597798s;animation-duration:4s">
                    <rect x="-4.432924083581787" y="-4.625279284889955" width="8.865848167163573" height="9.25055856977991" style="transform:scale(3.1407511559743115)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(1910.2704826787935 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.290957480923753s;animation-duration:4s">
                    <rect x="-5.854869290987189" y="-3.6978921371945397" width="11.709738581974378" height="7.395784274389079" style="transform:scale(3.4468307952687653)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(1828.8730762135128 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.131982274736197s;animation-duration:2s">
                    <rect x="-5.034471541368394" y="-4.079974674018069" width="10.068943082736787" height="8.159949348036138" style="transform:scale(2.378372551746545)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(682.3642754013458 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.4565419833123796s;animation-duration:2s">
                    <rect x="-4.392877185135031" y="-4.77645355555183" width="8.785754370270062" height="9.55290711110366" style="transform:scale(3.375854985150244)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(1018.1159900005024 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.33674470699052206s;animation-duration:2s">
                    <rect x="-5.345231397356617" y="-3.672393309894562" width="10.690462794713234" height="7.344786619789124" style="transform:scale(2.9497855387819705)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(339.4364354818086 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.7415464507574536s;animation-duration:4s">
                    <rect x="-4.711706723621279" y="-5.860062091113398" width="9.423413447242558" height="11.720124182226796" style="transform:scale(2.6599190108527946)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(618.9583905309153 0)">
                  <g class="ld ld-fall" style="animation-delay:-2.1989349866092907s;animation-duration:4s">
                    <rect x="-3.746414852707554" y="-3.21876863909164" width="7.492829705415108" height="6.43753727818328" style="transform:scale(2.450224240057091)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(1782.9297463411203 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.3207226232822062s;animation-duration:4s">
                    <rect x="-4.601346584637512" y="-4.073538111374056" width="9.202693169275024" height="8.147076222748112" style="transform:scale(2.1403270985771865)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(383.1695592214287 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.9374452358128416s;animation-duration:4s">
                    <rect x="-3.916217684733142" y="-4.210113646033524" width="7.832435369466284" height="8.420227292067048" style="transform:scale(2.9535921992613954)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(1847.725070998445 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.3590319220526297s;animation-duration:2s">
                    <rect x="-3.977459267201921" y="-3.1235485507092466" width="7.954918534403842" height="6.247097101418493" style="transform:scale(2.2430813377704766)" fill="#14d1bd"></rect>
                  </g></g><g transform="translate(1717.5414124902895 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.8760297617069948s;animation-duration:2s">
                    <rect x="-4.755498020480631" y="-3.1631798184280324" width="9.510996040961261" height="6.326359636856065" style="transform:scale(2.2498640491176087)" fill="#532788"></rect>
                  </g></g><g transform="translate(1037.7011248682456 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.5773940374123856s;animation-duration:4s">
                    <rect x="-3.4465436850760267" y="-5.391612727414335" width="6.893087370152053" height="10.78322545482867" style="transform:scale(2.7116824249657636)" fill="#751da7"></rect>
                  </g></g><g transform="translate(474.3257856693144 0)">
                  <g class="ld ld-fall" style="animation-delay:-1.3416058629384855s;animation-duration:2s">
                    <rect x="-4.100417576853397" y="-3.046403530329889" width="8.200835153706795" height="6.092807060659778" style="transform:scale(1.9767867057388697)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(484.77771529911206 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.8255453142379618s;animation-duration:4s">
                    <rect x="-3.744007503746709" y="-4.228125544918341" width="7.488015007493418" height="8.456251089836682" style="transform:scale(1.5226643880281645)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(602.2532804210856 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.331866850015472s;animation-duration:4s">
                    <rect x="-3.3580152237820715" y="-3.632689289055814" width="6.716030447564143" height="7.265378578111628" style="transform:scale(3.208446012693323)" fill="#fefefe"></rect>
                  </g></g><g transform="translate(479.94201725590784 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.6819915207492251s;animation-duration:4s">
                    <rect x="-3.7502289982534567" y="-4.635770524727144" width="7.500457996506913" height="9.271541049454289" style="transform:scale(2.0507127176291475)" fill="#c83a27"></rect>
                  </g></g><g transform="translate(358.3678429355483 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.0521038045671025s;animation-duration:4s">
                    <rect x="-3.076697144713918" y="-5.840158982850242" width="6.153394289427836" height="11.680317965700484" style="transform:scale(2.813297596574917)" fill="#366fa9"></rect>
                  </g></g><g transform="translate(151.50499673536245 0)">
                  <g class="ld ld-fall" style="animation-delay:-3.7350657345301244s;animation-duration:4s">
                    <rect x="-5.993483160798848" y="-5.561995388567664" width="11.986966321597697" height="11.123990777135328" style="transform:scale(2.803290489348631)" fill="#30aeb3"></rect>
                  </g></g><g transform="translate(1866.2436431744184 0)">
                  <g class="ld ld-fall" style="animation-delay:-0.3054434278540157s;animation-duration:4s">
                    <rect x="-5.850897730384758" y="-5.489110700859982" width="11.701795460769516" height="10.978221401719964" style="transform:scale(2.595888774288065)" fill="#366fa9"></rect>
                  </g></g></g></g>
            </svg>
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-lg-10 col-sm-12">
                  <div class="row justify-content-center">
                    <div class="col-12 col-sm-12 col-md-12 order-lg-1 order-md-1">
                      <div class="intro-message pt-5 mt-5">
                        <h1 class="h1-title w-100 d-block text-center">You did it - YOU are the champion 🥳</h1>
                        <div class="my-5 d-flex justify-content-center W-100">
                          <iframe class="youtube-vid align-self-center" src="https://www.youtube.com/embed/04854XqcfCY?start=39&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
        <img class="background-fixed-img" src="/img/startup-bg.jpg" alt="SPIRITT background">
    </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Navbar from './components/Navbar.vue';
  import JobHero from './components/JobHero.vue';
  import FloatingImages from './components/FloatingImages.vue';

  export default {
    name: 'applied',
    computed: {
      ...mapState('layout', {
        language: state => state.language,
      }),
      ...mapGetters({
        mobile: 'layout/mobile',
        modal: 'layout/modal',
        isScrolled: 'layout/isScrolled',
        isMvpModalOpen: 'layout/isMvpModalOpen',
      }),
    },
    components: {
      'navbar': Navbar,
      'job-hero': JobHero,
    },
    methods: {
      ...mapActions({
        updateModalTitle: 'layout/updateModalTitle',
        updateModalVisibility: 'layout/updateModalVisibility',
        updateModalContent: 'layout/updateModalContent',
        updateIsScrolled: 'layout/updateIsScrolled',
        updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
      }),
      handleScroll () {
        return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
          payload: {
            scrolled: window.scrollY,
          },
        });
      },
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll);
    },
  }
</script>
<style lang="css" scoped>
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
    #applied {
        font-family: Josefin Sans, sans-serif;
        font-size: 1.125rem;
        position: relative;
        overflow: hidden;
        scroll-behavior: smooth;
        display: block;
    }
    .background-fixed-img{
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        transition: opacity 1s;
        background-attachment: fixed;
        object-fit: cover;
        z-index: -1;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .background-fixed-img {
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 1;
            position: fixed;
            right: 0;
            top: 0;
            bottom: 0;
            transition: opacity 1s;
            z-index: -1;
        }
    }
    #hero-section {
      min-height: 100vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      color: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      content: "";
      z-index: 1;
      -webkit-box-align: center;
      -ms-flex-align: center;
      position: relative;
      /* background-image: url("/img/why-choose-us/background.svg"), linear-gradient(309deg, #000000 51%, #771bae);*/
      background-image: linear-gradient(309deg, #000000 51%, #771bae);
      background-attachment: fixed;
      font-size: 20px;
      background-size: cover;
    }
    .h1-title {
      font-size: 4rem !important;
    }
    .youtube-vid{
      max-width: 560px;
      min-height: 315px;
      width: 100%;
      border-radius: 2rem;
      object-fit: unset;
      -webkit-filter: drop-shadow(0px 0px 35px #fff);
      filter: drop-shadow(0px 0px 35px #fff);
    }
    @media (max-width: 780px) {
      .h1-title {

        font-size: 2.8rem !important;
      }
      #hero-section {
        min-height: calc(100vh);
        font-size: 16px !important;
      }

    }
    @keyframes ld-fall {
      0% { transform: translate(0,0px) rotate3d(1,1,1,0deg); }
      100% { transform: translate(0,969px) rotate3d(1,1,1,1080deg) ; }
    }
    .ld.ld-fall {
      animation: ld-fall 4s linear infinite;
      animation: ld-fall 1s linear infinite;
    }
</style>
